export default __webpack_public_path__ + "static/media/cert-startup-HKIRC.c253a062.jpg";